import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import Logo from './Logo';

const Navbar = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  const navLinks = [
    { href: '#about', label: t.nav.about },
    { href: '#gallery', label: t.nav.gallery },
    { href: '#videos', label: t.nav.videos },
    { href: '#services', label: t.nav.services },
    { href: '#packages', label: t.nav.packages },
    { href: '#vendors', label: t.nav.vendors },
    { href: '#contact', label: t.nav.contact },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-warm-beige shadow-lg' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <Logo isScrolled={isScrolled} />
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-serif text-deep-brown hover:text-terracotta transition-colors duration-300 text-lg tracking-wide"
              >
                {link.label}
              </a>
            ))}
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="font-serif text-deep-brown hover:text-terracotta transition-colors duration-300 text-sm px-3 py-1 border border-latte rounded-sm hover:border-terracotta shadow-embossed"
              aria-label="Toggle language"
            >
              {language === 'en' ? 'Español' : 'English'}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-deep-brown focus:outline-none p-2 -mr-2 touch-manipulation"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4 bg-warm-beige">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block py-3 px-4 font-serif text-deep-brown hover:text-terracotta hover:bg-rustic-cream/50 transition-colors touch-manipulation text-lg"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => {
                toggleLanguage();
                setIsOpen(false);
              }}
              className="block w-full text-left py-2 font-serif text-deep-brown hover:text-terracotta transition-colors border-t border-latte mt-2 pt-2"
            >
              {language === 'en' ? 'Español' : 'English'}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
